import * as path from "node:path";
import { buildSliceDirectoryPath } from "./buildSliceDirectoryPath.js";
const buildSliceFilePath = async (args) => {
  return path.join(await buildSliceDirectoryPath(args), args.filename);
};
export {
  buildSliceFilePath
};
//# sourceMappingURL=buildSliceFilePath.js.map
